module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "your-campaign"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "mb-30"
  }, [_vm._v(_vm._s(_vm.$t("project.yourCampaign")))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('choose-organization', {
    attrs: {
      "project": _vm.project,
      "errors": _vm.errors
    }
  }), _vm._v(" "), _c('fundraising-form', {
    attrs: {
      "project": _vm.project,
      "submit": _vm.submit,
      "errors": _vm.errors,
      "alert": _vm.alert
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container mt-50"
  }, [_c('verify-project', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg mt-20 button-wide-rais",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'show_fundraising',
          params: {
            id: _vm.project.id,
            title: _vm.project.title.replace(/ /g, '-')
          }
        })
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("project.showBtn")) + "\n      ")])]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "crowd-or-rais"
  }, [_c('span', {
    staticClass: "domore-yellow"
  }, [_vm._v("FUNDRAISING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-50 mb-50"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/star.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d04b0cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Fundraising/Edit.vue
// module id = 808
// module chunks = 1